// extracted by mini-css-extract-plugin
export var bubble = "_21-0";
export var container = "_21-f";
export var contrastBorder = "_21-g";
export var greyOut = "_21-2";
export var initialsColor0 = "_21-3";
export var initialsColor1 = "_21-4";
export var initialsColor10 = "_21-d";
export var initialsColor11 = "_21-e";
export var initialsColor2 = "_21-5";
export var initialsColor3 = "_21-6";
export var initialsColor4 = "_21-7";
export var initialsColor5 = "_21-8";
export var initialsColor6 = "_21-9";
export var initialsColor7 = "_21-a";
export var initialsColor8 = "_21-b";
export var initialsColor9 = "_21-c";
export var initialsWrapper = "_21-1";
export var large = "_21-l";
export var medium = "_21-k";
export var mediumSmall = "_21-j";
export var mediumSmallMedium = "_21-o";
export var micro = "_21-h";
export var small = "_21-i";
export var tiny = "_21-n";
export var xTiny = "_21-m";